import { useEffect, useState } from 'react';
import { TextField, Autocomplete } from '@mui/material';

interface IMultiFreeInputProps {
    width?: string | number;
    valueArray: string[];
    setValueArray: (valueArray: string[]) => boolean;
    setErrorMessage?: (errorMessage: string) => void;
}

const MultiFreeInput = ({ width, valueArray, setValueArray, setErrorMessage }: IMultiFreeInputProps) => {

    const [textInput, setTextInput] = useState("");

    return (
        <Autocomplete
            fullWidth={!width}
            sx={{ width }}
            multiple
            freeSolo
            value={valueArray}
            onChange={(_, value) => {
                const isSuccess = setValueArray(value);

                if (!isSuccess) setTextInput(value[value.length - 1]);
            }}
            inputValue={textInput}
            onInputChange={(_, value) => {
                if (setErrorMessage) setErrorMessage("");
                setTextInput(value);
            }}
            options={[]}
            renderInput={(params) => (
                <TextField
                    {...params}
                    onBlur={(event) => {
                        const value = event.target.value.trim();
                        if (!value || valueArray.includes(value)) return;

                        const isSuccess = setValueArray([...valueArray, value]);
                        if (isSuccess) setTextInput("");
                    }}
                    InputLabelProps={{
                        children: null,
                    }}
                />
            )}
        />
    );
};

export default MultiFreeInput;